export default {
    // 原搜索
    search: '/search',
    //登录
    login: '/login',

    //查询国家的
    selectAreaCountry: '/crDoc/selectAreaCountry',

    /**
     * 论文相关
     * */
    //创建论文
    addCrDoc: '/crDoc/addCrDoc',
    //查询论文列表 flag:0,//参会人2   管理员0
    selectUploadDocList: '/crDoc/selectUploadDocList',
    //查询论文列表 评审人角色使用的接口
    selectEvaluationDocList: '/crDoc/selectEvaluationDocList',
    // 论文=》查看详情
    selectUploadDocInfo: '/crDoc/selectUploadDocInfo',
    //论文=》编辑论文
    doUpdateDoc: '/crDoc/doUpdateDoc',
    //查看意见
    requestEvaluationList: '/crDoc/selectEvaluationList',
    //分配评审人接口
    assignEvaluation: '/crDoc/assignEvaluation',
    //批量修改评审结果 1:接受2:待定3:拒绝
    updateEvaluationResult: '/crDoc/updateEvaluationResult',
    //提交评审
    doNewInsertDocEvaluation: '/crDoc/doNewInsertDocEvaluation',
    //设置有效 无效
    updateDocisEnabled: '/crDoc/updateDocisEnabled',
    //批量下载导出论文
    docDownload: '/crDoc/export',
    //管理评审人列表
    selectReviewerOrgNameList: '/crDoc/selectReviewerOrgNameList',


    /**
     * 用户管理相关
     * */
    //请求excel数据。
    requestExcelData: '',
    //请求角色列表 根据当前角色
    requestRoleList: '/crRole/list',
    //权限列表
    getMenu: '/crRole/getMenu',
    //创建用户
    createAccountInfo:'/conference/user/createAccountInfo',
    //创建论文作者
    createDocAuthor:'/crDocAuthor/add',
    //查询机构列表
    queryLikeOrgName:'/conference/organ/queryLikeOrgName',
    //下载模板
    downloadTemplate:'/conference/user/downloadTemplate',
    //模板保存
    saveUserInfoRegister:'/conference/user/saveUserInfoRegister',
    //请求可创建用户权限
    getUserRoleRelationship:'/crRole/getUserRoleRelationship',
    // 下载zip
    downloadZip: '/crDoc/download',
}

